
export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getDeclension(number, nounFor1, nounFor2, nounFor5) {
  let numberAbs = Math.abs(number);
  let titles = [nounFor1, nounFor2, nounFor5];
  let cases = [2, 0, 1, 1, 1, 2];
  return titles[(numberAbs % 100 > 4 && numberAbs % 100 < 20) ? 2 : cases[(numberAbs % 10 < 5) ? numberAbs % 10 : 5]];
}
